// eslint-disable-next-line vue/multi-word-component-names
<script setup>
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import HeaderNav from "@/components/headerNav.vue";
import FootNav from "@/components/footNav.vue";
import banner1 from "@/assets/temporary/banner001.jpg";
import banner2 from "@/assets/temporary/banner010.jpg";
import {ElMessage} from "element-plus";
import {getBannerApi, createMessageApi,} from '@/api/index'
const bannerList = ref([
  { id: 1, title: '轮播图1' ,
    img: banner1
  },
  {
    img:banner2,id:2 ,title:'轮播图2'
  }
])
const router = useRouter()
const id = router.currentRoute.value.query.id
const form = ref({
  name: '',
  title: '',
  phone: '',
  content: '' ,

})
let isLoading = false
console.log(id)
function  getBanner (){
  getBannerApi({type:10}).then(res => {
    bannerList.value = res.data
  })
}
function submit() {
   if (isLoading){
     return
   }
  if (!form.value.title){
    return   ElMessage({message: t('请填写标题'), type: 'warning'})
  }
  if (!form.value.content){
    return   ElMessage({message: t('请填写内容'), type: 'warning'})
  }
  isLoading = true
  let data = {
    title: form.value.title,
    name: form.value.name,
    phone: form.value.phone,
    content: form.value.content,
    languageType:  localStorage.getItem('languageType') || 1 ,
    status :1
  }
  createMessageApi( data ).then(res=>{
    if (res.code === 0){
      ElMessage({message: t('提交成功'), type: 'success'})
      form.value = {}
      isLoading = false
    }
  })
}
getBanner()
</script>

<template>

  <div class="box">
    <HeaderNav :isCurrent="9" />
    <div>
      <!-- 轮播图 -->
      <el-carousel height="600px" autoplay>
        <el-carousel-item style="height: auto ;min-height: 600px" v-for="(item ,index) in bannerList" :key="index">
          <img :src="item.picUrl" :alt="item.title">
        </el-carousel-item>
      </el-carousel>
    </div>
    <!--产品展示 开始-->
    <div class="single">
      <!--右侧区域 开始-->
      <div id="right">
        <div id="subchannel_main">
          <div id="subchannel">
            <ul class="subchannellist">
              <li class="depth1" id="current">
                <a href="javascript:;"> {{t('在线留言')}}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="right_body minwidth">
          <div class="ChannelContent">
            <el-form :model="form" label-width="120px" label-position="left">
              <el-form-item :label="t('标题')">
                <el-input v-model="form.title" :placeholder="t('请填写标题')" />
              </el-form-item>
              <el-form-item :label="t('姓名')" >
                <el-input v-model="form.name" :placeholder="t('请填写姓名')" />
              </el-form-item>
              <el-form-item :label="t('电话')">
                <el-input v-model="form.phone"  :placeholder="t('请填写电话')" />
              </el-form-item>
              <el-form-item :label="t('内容')">
                <el-input type="textarea" v-model="form.content" :placeholder="t('请填写内容')" />
              </el-form-item>
              <el-form-item label="">
                 <div class="btn form_button" @click="submit " >{{t('提交消息')}}</div>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="right_bottom"></div>
      </div>
      <!--右侧区域 结束-->
      <div class="clear"></div>
    </div>
    <!--产品展示 结束-->

    <FootNav />
  </div>
</template>

<style scoped lang="scss">
.video-details {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;

  h1 {
    color: #333;
    margin-bottom: 20px;
  }

  .video-container {
    margin-top: 20px;
    padding: 20px;
    background-color: #f5f5f5;
    border-radius: 8px;
    min-height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.form_button {
  margin: 0 auto;
}
</style>